"use client"

import { AppProgressBar } from "next-nprogress-bar"
import type { ReactNode } from "react"

const Providers = ({ children }: { children: ReactNode }) => {

  return (
    <>
      <AppProgressBar
        height="2px"
        color="#1E4259"
        options={{
          showSpinner: false,
        }}
        delay={120}
        stopDelay={120}
      />
      {children}
    </>
  )
}

export default Providers
